var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"body-margin main-margin d-flex justify-center align-center"},[_vm._t("message")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }